export const FETCH_LDAP_SEARCH_SUCCESS = 'FETCH_LDAP_SEARCH_SUCCESS';
export const FETCH_LDAP_SEARCH_INPROGRESS = 'FETCH_LDAP_SEARCH_INPROGRESS';
export const FETCH_LDAP_SEARCH_ERROR = 'FETCH_LDAP_SEARCH_ERROR';